import * as React from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
};
var SvgSeagull = function SvgSeagull(_ref) {
  var fill = _ref.fill,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '32px' : _ref$height,
    width = _ref.width;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    height: height,
    style: {
      enableBackground: 'new 0 0 32 32'
    },
    fill: fill,
    role: "img",
    viewBox: "0 0 32 32",
    width: width
  }, /*#__PURE__*/React.createElement("title", null, "hollister co."), /*#__PURE__*/React.createElement("path", {
    d: "M26.95 10.805c-.902-.296-2.087-.344-3.044-.424-1.062-.09-1.689.073-2.551.123-1.069.063-4.978 3.943-7.805 7.172 0 0-2.067-1.616-3.588-2.505-1.52-.892-1.881-1.031-2.864-.38s-6.657 3.195-6.08 3.316c.577.117 3.081.356 4.067.224.989-.136 2.597-1.058 2.597-1.058l2.59 1.607c-.2.114-.398.229-.598.342-.122.07-.248.135-.366.207-.247.154-.407.479-.572.711-.029.039-.299.176-.343.209-.282.209-.583.439-.61.58-.06.305.098.432.409.334.591-.182 1.273-.334 1.273-.334l1.342.424s1.415.397 3.377.258c.351-.024 4.433-.969 4.433-.969s2.418.721 2.692.825c.269.103 1.597-.104 2.133-.413.537-.309 1.711-1.705 1.725-2.009.014-.302-2.876-.604-3.261-.642-.943-.094-2.683-.094-2.683-.094s1.612-4.105 2.838-5.378c1.229-1.275 7.053.033 8.578-.409 1.521-.443-1.848-1.119-3.688-1.72l-.001.003z"
  }));
};
SvgSeagull.propTypes = propTypes;

export { SvgSeagull as default };
//# sourceMappingURL=Seagull.js.map
